import { LinearProgress } from "@mui/material";
import React from "react";

export interface ProgressBarProps {
  progressPercentage: number;
  color?: string;
  height?: number;
  width?: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progressPercentage,
  color,
  height,
  width,
}) => {
  return (
    <LinearProgress
      variant="determinate"
      value={progressPercentage}
      sx={{
        height: height,
        width: width,
        borderRadius: 5,
        backgroundColor: "#f2f2f2",
        "& .MuiLinearProgress-bar": {
          backgroundColor: color || "#000000",
        },
      }}
    />
  );
};

export default ProgressBar;
